import React, { useEffect, useState } from 'react';

import GeneralRiskProbabilitiesTableEditRow from './GeneralRiskProbabilitiesTableEditRow';
import GeneralRiskProbabilitiesTableRow from './GeneralRiskProbabilitiesTableRow';

import Toast from 'CommonComponents/Toast';

export default function GeneralRiskProbabilitiesTable(props) {
    const [probabilities, setProbabilities] = useState([]);
    const [editableProbability, setEditableProbability] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchGeneralRiskProbabilities();
    }, []);

    const fetchGeneralRiskProbabilities = () => {
        setIsLoading(true);
        axios
            .get(props.fetchUrl)
            .then(({ data }) => {
                setProbabilities([...data]);
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const prepareUpdateUrl = (probability) => {
        return props.updateUrl.replace('PROBABILITY_ID', probability.id);
    };

    return (
        <>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-w-20">{$t('Percentage')}</th>
                            <th className="tw-w-44">{$t('Probability')}</th>
                            <th>{$t('Description')}</th>
                            <th className="tw-w-40">{$t('Actions')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!isLoading &&
                            !!probabilities?.length &&
                            probabilities.map((probability) => {
                                if (editableProbability && parseInt(editableProbability.id) === parseInt(probability.id)) {
                                    return (
                                        <GeneralRiskProbabilitiesTableEditRow
                                            key={probability.id}
                                            probability={probability}
                                            onUpdated={fetchGeneralRiskProbabilities}
                                            updateUrl={prepareUpdateUrl(probability)}
                                            onCancel={() => setEditableProbability(null)}
                                            onEdit={() => setEditableProbability(probability)}
                                        />
                                    );
                                } else {
                                    return (
                                        <GeneralRiskProbabilitiesTableRow
                                            key={probability.id}
                                            probability={probability}
                                            onEdit={() => setEditableProbability(probability)}
                                        />
                                    );
                                }
                            })}
                        {isLoading && (
                            <tr>
                                <td colSpan="100">{$t('Loading')}...</td>
                            </tr>
                        )}
                        {!isLoading && !probabilities?.length && (
                            <tr>
                                <td colSpan="100">{$t('No Probabilities found')}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Toast id="general-risk-probability-update-toast" message={$t('general risk probability updated successfully')} />
            <Toast id="general-risk-probability-update-failed-toast" message={$t('general risk probability update failed')} />
        </>
    );
}
